import { FlowNodeTypes } from '../types'

// V2.9 is a real node type: it saves and loads as `ai_agent_v29`, and
// agent-runner switches on that type. Everything else — sidebar, defaults,
// output states, schema, nodevars, channels — is shared with ai_agent_v2.
export const AI_AGENT_V29_LABEL = 'AI Conversation V2.9'
// Node names prefix {{Node.var}} references, so a default name cannot contain a dot.
export const AI_AGENT_V29_DEFAULT_NAME = 'Smart AI Conversation'

// The two builder types are the same node everywhere except the palette entry
// and the Extract Variables panel.
export const isAiAgentV2Type = (type?: string | null): boolean =>
  type === FlowNodeTypes.ai_agent_v2 || type === FlowNodeTypes.ai_agent_v29
